/**
 * localStorage wrapper that fails gracefully in private mode, when storage is full,
 * or when the API is unavailable (e.g. some Office.js sandboxes).
 */
import { debugLog } from '@/debug'

export const safeStorage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      debugLog.add('warn', `storage.get(${key}) failed: ${(e as Error).message}`)
      return null
    }
  },

  set(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value)
      return true
    } catch (e) {
      debugLog.add('warn', `storage.set(${key}) failed: ${(e as Error).message}`)
      return false
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      debugLog.add('warn', `storage.remove(${key}) failed: ${(e as Error).message}`)
    }
  },
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'korus-access-token',
  REFRESH_TOKEN: 'korus-refresh-token',
  USER: 'korus-user',
  LOCALE: 'korus-locale',
} as const
